export const usedLocale = document.getElementsByTagName('meta')['locale_used'].getAttribute('content')
export const defaultLocale = document.getElementsByTagName('meta')['locale_default'].getAttribute('content')
export const blockLocale = document.getElementsByTagName('meta')['blocklocale_used'].getAttribute('content')

export default {
  usedLocale: usedLocale,
  defaultLocale: defaultLocale,
  blockLocale: blockLocale
}



// WEBPACK FOOTER //
// ./client/plugins/wsc-locales.js